<template>
    <div class="d-flex flex-column">
        <div class="d-flex">
            <span>{{ value.name }}</span>
        </div>
    </div>
</template>

<script>
export default {
  name: "NewsAuthorCell",
  props: {
      value: {},
      extraValue: {}
  }
}
</script>

<style scoped>

</style>